const CheckmarkIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0433 3.76797C16.7902 3.51484 16.3964 3.51484 16.1433 3.76797L6.58082 13.0492L1.85582 8.40859C1.60269 8.15547 1.20894 8.18359 0.955819 8.40859C0.702694 8.66172 0.730819 9.05547 0.955819 9.30859L5.93394 14.1461C6.10269 14.3148 6.32769 14.3992 6.58082 14.3992C6.83394 14.3992 7.03082 14.3148 7.22769 14.1461L17.0433 4.61172C17.2964 4.41484 17.2964 4.02109 17.0433 3.76797Z"
        fill="#1A8245"
      />
    </svg>
  );
};

export default CheckmarkIcon;
